import styled from 'styled-components';

interface IAsideFlexProps {
  side?: string;
}

export const AsideFlex = styled.div<IAsideFlexProps>`
  display: flex;
  flex: 1;
  text-align: ${props => props.side || 'left'};
  justify-content: ${props => props.side || 'left'};
`;